import { createAffiliate } from './createAffiliate';
import { fetchAffiliate } from './fetchAffiliate';
import { fetchAffiliates } from './fetchAffiliates';
import { updateAffiliate } from './updateAffiliate';

export const affiliateService = {
  createAffiliate,
  fetchAffiliate,
  fetchAffiliates,
  updateAffiliate,
};
